import { motion } from 'motion/react'

export function BlurLighting() {
  return (
    <svg
      className="block size-full overflow-visible"
      fill="none"
      viewBox="0 0 164.365 111.957"
      preserveAspectRatio="none"
    >
      <g>
        <motion.g
          filter="url(#blur-spot-filter-a)"
          initial={{ opacity: 0, scale: 0, x: 0 }}
          animate={{
            opacity: [0, 1, 1, 1, 1],
            scale: [0, 1, 1.8, 2.2, 2.2],
            x: [0, 0, 0, 40, 40],
            filter: [
              'blur(0px)',
              'blur(0px)',
              'blur(3px)',
              'blur(8px)',
              'blur(8px)',
            ],
          }}
          transition={{
            duration: 12,
            ease: [0.25, 0.1, 0.25, 1],
            repeat: Infinity,
            repeatType: 'reverse',
            times: [0, 0.25, 0.5, 0.85, 1],
          }}
          style={{
            transformOrigin: '50% 50%',
            transformBox: 'fill-box' as const,
          }}
        >
          <ellipse
            cx="22.0638"
            cy="89.7946"
            rx="10.3749"
            ry="10.4766"
            fill="#F1FFD5"
            fillOpacity="0.28"
            transform="rotate(7.295 22.0638 89.7946)"
          />
        </motion.g>
        <motion.g
          filter="url(#blur-spot-filter-b)"
          initial={{ opacity: 0, scale: 0 }}
          animate={{
            opacity: [0, 1, 1, 0.5, 0],
            scale: [0, 1, 0.6, 0.3, 0],
          }}
          transition={{
            duration: 12,
            ease: [0.25, 0.1, 0.25, 1],
            repeat: Infinity,
            repeatType: 'reverse',
            times: [0, 0.25, 0.5, 0.75, 1],
          }}
          style={{
            transformOrigin: '50% 50%',
            transformBox: 'fill-box' as const,
          }}
        >
          <ellipse
            cx="122.377"
            cy="42.2761"
            rx="30.2944"
            ry="30.5914"
            fill="#F1FFD5"
            fillOpacity="0.28"
            transform="rotate(7.295 122.377 42.2761)"
          />
        </motion.g>
      </g>
      <defs>
        <filter
          id="blur-spot-filter-a"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          x="0"
          y="67.632"
          width="44.128"
          height="44.325"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            mode="normal"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5.843"
            result="effect1_foregroundBlur"
          />
        </filter>
        <filter
          id="blur-spot-filter-b"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          x="80.388"
          y="0"
          width="83.977"
          height="84.552"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            mode="normal"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5.843"
            result="effect1_foregroundBlur"
          />
        </filter>
      </defs>
    </svg>
  )
}
